import {
  intradayPeriodicity,
  hourPeriodicity,
  dayPeriodicity,
  weekPeriodicity,
  monthPeriodicity
} from "./Periodicity";

export const INTRADAY = {
  base: "today",
  multiplier: 1,
  periodicity: intradayPeriodicity
};

export const FIVE_DAYS = {
  base: "day",
  multiplier: 5,
  periodicity: hourPeriodicity,
  dontRoll: true
};

export const ONE_MONTH = {
  base: "month",
  multiplier: 1,
  periodicity: dayPeriodicity
};

export const THREE_MONTHS = {
  base: "month",
  multiplier: 3,
  periodicity: dayPeriodicity
};

export const SIX_MONTHS = {
  base: "month",
  multiplier: 6,
  periodicity: dayPeriodicity
};

export const YTD = {
  base: "ytd",
  multiplier: 1,
  periodicity: dayPeriodicity
};

export const ONE_YEAR = {
  base: "year",
  multiplier: 1,
  periodicity: dayPeriodicity
};

export const THREE_YEARS = {
  base: "year",
  multiplier: 3,
  periodicity: weekPeriodicity
};

export const FIVE_YEARS = {
  base: "year",
  multiplier: 5,
  periodicity: weekPeriodicity
};

export const TEN_YEARS = {
  base: "year",
  multiplier: 10,
  periodicity: weekPeriodicity
};

export const MAX = {
  base: "year",
  multiplier: 10,
  periodicity: weekPeriodicity
};
